/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { analyticsOverviewGet$Json } from '../fn/analytics/analytics-overview-get-json';
import { AnalyticsOverviewGet$Json$Params } from '../fn/analytics/analytics-overview-get-json';
import { analyticsOverviewGet$Plain } from '../fn/analytics/analytics-overview-get-plain';
import { AnalyticsOverviewGet$Plain$Params } from '../fn/analytics/analytics-overview-get-plain';
import { analyticsTopDashboardsGet$Json } from '../fn/analytics/analytics-top-dashboards-get-json';
import { AnalyticsTopDashboardsGet$Json$Params } from '../fn/analytics/analytics-top-dashboards-get-json';
import { analyticsTopDashboardsGet$Plain } from '../fn/analytics/analytics-top-dashboards-get-plain';
import { AnalyticsTopDashboardsGet$Plain$Params } from '../fn/analytics/analytics-top-dashboards-get-plain';
import { analyticsTopQueriesGet$Json } from '../fn/analytics/analytics-top-queries-get-json';
import { AnalyticsTopQueriesGet$Json$Params } from '../fn/analytics/analytics-top-queries-get-json';
import { analyticsTopQueriesGet$Plain } from '../fn/analytics/analytics-top-queries-get-plain';
import { AnalyticsTopQueriesGet$Plain$Params } from '../fn/analytics/analytics-top-queries-get-plain';
import { DashboardUsageDto } from '../models/dashboard-usage-dto';
import { QueryUsageDto } from '../models/query-usage-dto';
import { UsageOverviewDto } from '../models/usage-overview-dto';

@Injectable({ providedIn: 'root' })
export class AnalyticsApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `analyticsOverviewGet()` */
  static readonly AnalyticsOverviewGetPath = '/analytics/overview';

  /**
   * Usage overview.
   *
   * Returns high-level usage metrics for the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analyticsOverviewGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsOverviewGet$Plain$Response(params?: AnalyticsOverviewGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageOverviewDto>> {
    const obs = analyticsOverviewGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Usage overview.
   *
   * Returns high-level usage metrics for the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analyticsOverviewGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsOverviewGet$Plain(params?: AnalyticsOverviewGet$Plain$Params, context?: HttpContext): Observable<UsageOverviewDto> {
    const resp = this.analyticsOverviewGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UsageOverviewDto>): UsageOverviewDto => r.body)
    );
  }

  /**
   * Usage overview.
   *
   * Returns high-level usage metrics for the current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analyticsOverviewGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsOverviewGet$Json$Response(params?: AnalyticsOverviewGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageOverviewDto>> {
    const obs = analyticsOverviewGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Usage overview.
   *
   * Returns high-level usage metrics for the current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analyticsOverviewGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsOverviewGet$Json(params?: AnalyticsOverviewGet$Json$Params, context?: HttpContext): Observable<UsageOverviewDto> {
    const resp = this.analyticsOverviewGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UsageOverviewDto>): UsageOverviewDto => r.body)
    );
  }

  /** Path part for operation `analyticsTopDashboardsGet()` */
  static readonly AnalyticsTopDashboardsGetPath = '/analytics/top-dashboards';

  /**
   * Top dashboards.
   *
   * Lists dashboards ordered by usage count.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analyticsTopDashboardsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsTopDashboardsGet$Plain$Response(params?: AnalyticsTopDashboardsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardUsageDto>>> {
    const obs = analyticsTopDashboardsGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Top dashboards.
   *
   * Lists dashboards ordered by usage count.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analyticsTopDashboardsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsTopDashboardsGet$Plain(params?: AnalyticsTopDashboardsGet$Plain$Params, context?: HttpContext): Observable<Array<DashboardUsageDto>> {
    const resp = this.analyticsTopDashboardsGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DashboardUsageDto>>): Array<DashboardUsageDto> => r.body)
    );
  }

  /**
   * Top dashboards.
   *
   * Lists dashboards ordered by usage count.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analyticsTopDashboardsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsTopDashboardsGet$Json$Response(params?: AnalyticsTopDashboardsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardUsageDto>>> {
    const obs = analyticsTopDashboardsGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Top dashboards.
   *
   * Lists dashboards ordered by usage count.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analyticsTopDashboardsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsTopDashboardsGet$Json(params?: AnalyticsTopDashboardsGet$Json$Params, context?: HttpContext): Observable<Array<DashboardUsageDto>> {
    const resp = this.analyticsTopDashboardsGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<DashboardUsageDto>>): Array<DashboardUsageDto> => r.body)
    );
  }

  /** Path part for operation `analyticsTopQueriesGet()` */
  static readonly AnalyticsTopQueriesGetPath = '/analytics/top-queries';

  /**
   * Top queries.
   *
   * Lists queries ordered by usage count.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analyticsTopQueriesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsTopQueriesGet$Plain$Response(params?: AnalyticsTopQueriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<QueryUsageDto>>> {
    const obs = analyticsTopQueriesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Top queries.
   *
   * Lists queries ordered by usage count.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analyticsTopQueriesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsTopQueriesGet$Plain(params?: AnalyticsTopQueriesGet$Plain$Params, context?: HttpContext): Observable<Array<QueryUsageDto>> {
    const resp = this.analyticsTopQueriesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<QueryUsageDto>>): Array<QueryUsageDto> => r.body)
    );
  }

  /**
   * Top queries.
   *
   * Lists queries ordered by usage count.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `analyticsTopQueriesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsTopQueriesGet$Json$Response(params?: AnalyticsTopQueriesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<QueryUsageDto>>> {
    const obs = analyticsTopQueriesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Top queries.
   *
   * Lists queries ordered by usage count.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `analyticsTopQueriesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  analyticsTopQueriesGet$Json(params?: AnalyticsTopQueriesGet$Json$Params, context?: HttpContext): Observable<Array<QueryUsageDto>> {
    const resp = this.analyticsTopQueriesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<QueryUsageDto>>): Array<QueryUsageDto> => r.body)
    );
  }

}
